import SDK from '../../Components/SDK';
import { Store } from '../../store';
import IndexedDb from '../IndexedDb';
import { GroupsMemberListAction, GroupsMemberParticipantsListAction } from '../../Actions/GroupsAction';
import { getUserIdFromJid } from '../Utility';
const indexedDb = new IndexedDb();

export const setGroupParticipants = res => {
    Store.dispatch(GroupsMemberListAction(res));
};

export const setGroupParticipantsByGroupId = (groupId, participantsList) => {
    // Safety check: handle empty, undefined, or null participantsList
    if (!participantsList || !Array.isArray(participantsList) || participantsList.length === 0) {
        Store.dispatch(
            GroupsMemberParticipantsListAction({
                groupId: groupId,
                participantsList: [],
            }),
        );
        return;
    }

    const uniqueUserJids = {};
    const uniqueParticipantsList = participantsList.filter(item => {
        if (item.userType !== '' && !uniqueUserJids[item.userJid]) {
            uniqueUserJids[item.userJid] = true;
            return true;
        }
        return false;
    });

    Store.dispatch(
        GroupsMemberParticipantsListAction({
            groupId: groupId,
            participantsList: uniqueParticipantsList,
        }),
    );
};

/**
 * Get the group data from groups list
 * @param {*} groupId
 */
export const getGroupData = (groupId = '') => {
    const { data: groupData } = Store.getState().groupsData;
    return groupData?.find(obj => groupId.indexOf(obj.groupId) > -1);
};

/**
 * The group's image and description as the server holds them now.
 *
 * set_group_info replaces the whole vCard, so every edit has to resend these; the cached
 * group list can be stale, so the server copy is read first and the cache is the fallback.
 *
 * @param {string} groupJid Group JID.
 * @returns {Promise<{groupImage: string, thumbImage: string, groupDescription: string}>} The profile.
 */
export const getLatestGroupProfile = async groupJid => {
    const response = await SDK.getGroupProfile(groupJid);
    const group = response?.statusCode === 200 && response.data?.groupId ? response.data : getGroupData(groupJid);
    return {
        groupImage: group?.groupImage || '',
        thumbImage: group?.thumbImage || '',
        groupDescription: group?.groupDescription || '',
    };
};

const DISAPPEAR_NOTIFICATION_CODES = ['21', '22', '23'];

/**
 * Whether a group profile event changed the disappearing timer.
 *
 * The server resends the stored timer with every profile edit, so the vCard alone cannot
 * tell; the event code can. Without a code (older server) any timer in the vCard counts.
 *
 * @param {object} event groupProfileListener payload.
 * @returns {boolean} True for a timer change.
 */
export const isGroupDisappearNotice = event =>
    event?.groupProfile?.msgDisappear !== undefined &&
    (!event.notificationCode || DISAPPEAR_NOTIFICATION_CODES.includes(event.notificationCode));

/**
 * Check Given user exist in group or not
 */
export const isUserExistInGroup = (userId, groupUsers) => {
    if (!userId || (groupUsers && !Array.isArray(groupUsers))) return false;

    if (!groupUsers) {
        const { groupsMemberListData: { data: { participants } = {} } = {} } = Store.getState();
        if (!participants) return false;
        groupUsers = participants;
    }
    return groupUsers.some(user => user.userId === userId);
};

/**
 * Check Given user exist in group or not
 */
export const getUserFromGroup = (userId, groupUsers) => {
    if (!userId || (groupUsers && !Array.isArray(groupUsers))) return false;
    userId = getUserIdFromJid(userId);
    if (!groupUsers) {
        const { groupsMemberListData: { data: { participants } = {} } = {} } = Store.getState();
        if (!participants) return false;
        groupUsers = participants;
    }
    return groupUsers.find(user => user.userId === userId);
};
